module.exports = __webpack_public_path__ + "img/footOne.fca6241e.png";